module.exports = __webpack_public_path__ + "static/media/bg_img.ded2c0aa.png";